import * as e from "react";
import t, { createContext as r, Component as n, useState as o, useEffect as s, useContext as a } from "react";
import { initialize as l } from "launchdarkly-js-client-sdk";
export * from "launchdarkly-js-client-sdk";
import i from "lodash.camelcase";
import c from "hoist-non-react-statics";
const p = {
    useCamelCaseFlagKeys: !0,
    sendEventsOnFlagRead: !0
  },
  u = r({
    flags: {},
    flagKeyMap: {},
    ldClient: void 0
  }),
  {
    Provider: f,
    Consumer: y
  } = u,
  d = e => {
    var t;
    return null != (t = e.context) ? t : e.user;
  },
  g = e => {
    const t = {};
    for (const r in e) 0 !== r.indexOf("$") && (t[i(r)] = e[r]);
    return t;
  },
  b = (e, t) => {
    const r = {};
    for (const n in e) t && void 0 === t[n] || (r[n] = e[n].current);
    return r;
  },
  h = (e, t) => {
    const r = e.allFlags();
    return t ? Object.keys(t).reduce((e, n) => (e[n] = Object.prototype.hasOwnProperty.call(r, n) ? r[n] : t[n], e), {}) : r;
  };
g.camelCaseKeys = g;
var O = Object.defineProperty,
  m = Object.getOwnPropertySymbols,
  v = Object.prototype.hasOwnProperty,
  j = Object.prototype.propertyIsEnumerable,
  P = (e, t, r) => t in e ? O(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  w = (e, t) => {
    for (var r in t || (t = {})) v.call(t, r) && P(e, r, t[r]);
    if (m) for (var r of m(t)) j.call(t, r) && P(e, r, t[r]);
    return e;
  };
const C = {
    wrapperName: "react-client-sdk",
    wrapperVersion: "3.0.9",
    sendEventsOnlyForVariation: !0
  },
  x = function (e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }
    return r = void 0, n = [e, ...t], o = function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        anonymous: !0,
        kind: "user"
      };
      let r = arguments.length > 2 ? arguments[2] : undefined;
      let n = arguments.length > 3 ? arguments[3] : undefined;
      return function* () {
        const o = l(e, t, w(w({}, C), r));
        return new Promise(e => {
          function t() {
            o.off("ready", s), o.off("failed", r);
          }
          function r(r) {
            t(), e({
              flags: {},
              ldClient: o,
              error: r
            });
          }
          function s() {
            t();
            const r = h(o, n);
            e({
              flags: r,
              ldClient: o
            });
          }
          o.on("failed", r), o.on("ready", s);
        });
      }();
    }, new Promise((e, t) => {
      var s = e => {
          try {
            l(o.next(e));
          } catch (e) {
            t(e);
          }
        },
        a = e => {
          try {
            l(o.throw(e));
          } catch (e) {
            t(e);
          }
        },
        l = t => t.done ? e(t.value) : Promise.resolve(t.value).then(s, a);
      l((o = o.apply(r, n)).next());
    });
    var r, n, o;
  };
function F(e, t) {
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : p;
  let n = arguments.length > 3 ? arguments[3] : undefined;
  const o = function (e, t) {
      if (void 0 === t) return e;
      return Object.keys(t).reduce((t, r) => (E(e, r) && (t[r] = e[r]), t), {});
    }(t, n),
    {
      useCamelCaseFlagKeys: s = !0
    } = r,
    [a, l = {}] = s ? function (e) {
      const t = {},
        r = {};
      for (const n in e) {
        if (0 === n.indexOf("$")) continue;
        const o = i(n);
        t[o] = e[n], r[o] = n;
      }
      return [t, r];
    }(o) : [o];
  return {
    flags: r.sendEventsOnFlagRead ? K(e, a, l, s) : a,
    flagKeyMap: l
  };
}
function E(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function K(e, t, r, n) {
  return new Proxy(t, {
    get(t, o, s) {
      const a = Reflect.get(t, o, s),
        l = n && E(r, o) || E(t, o);
      if ("symbol" == typeof o || !l) return a;
      if (void 0 === a) return;
      const i = n ? r[o] : o;
      return e.variation(i, a);
    }
  });
}
var S = Object.defineProperty,
  k = Object.defineProperties,
  D = Object.getOwnPropertyDescriptors,
  I = Object.getOwnPropertySymbols,
  M = Object.prototype.hasOwnProperty,
  R = Object.prototype.propertyIsEnumerable,
  L = (e, t, r) => t in e ? S(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  z = (e, t) => {
    for (var r in t || (t = {})) M.call(t, r) && L(e, r, t[r]);
    if (I) for (var r of I(t)) R.call(t, r) && L(e, r, t[r]);
    return e;
  },
  T = (e, t, r) => (L(e, "symbol" != typeof t ? t + "" : t, r), r),
  V = (e, t, r) => new Promise((n, o) => {
    var s = e => {
        try {
          l(r.next(e));
        } catch (e) {
          o(e);
        }
      },
      a = e => {
        try {
          l(r.throw(e));
        } catch (e) {
          o(e);
        }
      },
      l = e => e.done ? n(e.value) : Promise.resolve(e.value).then(s, a);
    l((r = r.apply(e, t)).next());
  });
class $ extends n {
  constructor(e) {
    super(e), T(this, "state"), T(this, "getReactOptions", () => z(z({}, p), this.props.reactOptions)), T(this, "subscribeToChanges", e => {
      const {
        flags: t
      } = this.props;
      e.on("change", r => {
        const n = this.getReactOptions(),
          o = b(r, t),
          s = z(z({}, this.state.unproxiedFlags), o);
        Object.keys(o).length > 0 && this.setState(z({
          unproxiedFlags: s
        }, F(e, s, n, t)));
      });
    }), T(this, "initLDClient", () => V(this, null, function* () {
      const {
        clientSideID: e,
        flags: t,
        options: r
      } = this.props;
      let n = yield this.props.ldClient;
      const o = this.getReactOptions();
      let s,
        a = this.state.unproxiedFlags;
      if (n) a = h(n, t);else {
        const o = yield x(e, d(this.props), r, t);
        s = o.error, s || (a = o.flags), n = o.ldClient;
      }
      var l;
      this.setState((l = z({
        unproxiedFlags: a
      }, F(n, a, o, t)), k(l, D({
        ldClient: n,
        error: s
      })))), this.subscribeToChanges(n);
    }));
    const {
      options: t
    } = e;
    if (this.state = {
      flags: {},
      unproxiedFlags: {},
      flagKeyMap: {},
      ldClient: void 0
    }, t) {
      const {
        bootstrap: e
      } = t;
      if (e && "localStorage" !== e) {
        const {
          useCamelCaseFlagKeys: t
        } = this.getReactOptions();
        this.state = {
          flags: t ? g(e) : e,
          unproxiedFlags: e,
          flagKeyMap: {},
          ldClient: void 0
        };
      }
    }
  }
  componentDidMount() {
    return V(this, null, function* () {
      const {
        deferInitialization: e
      } = this.props;
      e && !d(this.props) || (yield this.initLDClient());
    });
  }
  componentDidUpdate(e) {
    return V(this, null, function* () {
      const {
          deferInitialization: t
        } = this.props,
        r = !d(e) && d(this.props);
      t && r && (yield this.initLDClient());
    });
  }
  render() {
    const {
      flags: e,
      flagKeyMap: r,
      ldClient: n,
      error: o
    } = this.state;
    return t.createElement(f, {
      value: {
        flags: e,
        flagKeyMap: r,
        ldClient: n,
        error: o
      }
    }, this.props.children);
  }
}
var N = Object.defineProperty,
  U = Object.defineProperties,
  q = Object.getOwnPropertyDescriptors,
  A = Object.getOwnPropertySymbols,
  B = Object.prototype.hasOwnProperty,
  G = Object.prototype.propertyIsEnumerable,
  H = (e, t, r) => t in e ? N(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  J = (e, t) => {
    for (var r in t || (t = {})) B.call(t, r) && H(e, r, t[r]);
    if (A) for (var r of A(t)) G.call(t, r) && H(e, r, t[r]);
    return e;
  };
function Q(t) {
  return function (r) {
    const {
        reactOptions: n
      } = t,
      o = J(J({}, p), n),
      s = (a = J({}, t), U(a, q({
        reactOptions: o
      })));
    var a;
    function l(t) {
      return e.createElement($, J({}, s), e.createElement(r, J({}, t)));
    }
    return c(l, r), l;
  };
}
var W = Object.defineProperty,
  X = Object.getOwnPropertySymbols,
  Y = Object.prototype.hasOwnProperty,
  Z = Object.prototype.propertyIsEnumerable,
  _ = (e, t, r) => t in e ? W(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  ee = (e, t) => {
    for (var r in t || (t = {})) Y.call(t, r) && _(e, r, t[r]);
    if (X) for (var r of X(t)) Z.call(t, r) && _(e, r, t[r]);
    return e;
  };
function te(e) {
  return r = this, n = null, a = function* () {
    const {
        clientSideID: r,
        flags: n,
        options: a,
        reactOptions: l
      } = e,
      i = ee(ee({}, p), l),
      {
        ldClient: c,
        flags: u,
        error: y
      } = yield x(r, d(e), a, n),
      g = (null == a ? void 0 : a.bootstrap) && "localStorage" !== a.bootstrap ? a.bootstrap : u;
    return _ref => {
      let {
        children: e
      } = _ref;
      const [r, a] = o(() => ee({
        unproxiedFlags: g
      }, F(c, g, i, n)));
      s(() => {
        function e(e) {
          const t = b(e, n);
          Object.keys(t).length > 0 && a(_ref2 => {
            let {
              unproxiedFlags: e
            } = _ref2;
            const r = ee(ee({}, e), t);
            return ee({
              unproxiedFlags: r
            }, F(c, r, i, n));
          });
        }
        return c.on("change", e), function () {
          c.off("change", e);
        };
      }, []);
      const {
        flags: l,
        flagKeyMap: p
      } = r;
      return t.createElement(f, {
        value: {
          flags: l,
          flagKeyMap: p,
          ldClient: c,
          error: y
        }
      }, e);
    };
  }, new Promise((e, t) => {
    var o = e => {
        try {
          l(a.next(e));
        } catch (e) {
          t(e);
        }
      },
      s = e => {
        try {
          l(a.throw(e));
        } catch (e) {
          t(e);
        }
      },
      l = t => t.done ? e(t.value) : Promise.resolve(t.value).then(o, s);
    l((a = a.apply(r, n)).next());
  });
  var r, n, a;
}
var re = Object.defineProperty,
  ne = Object.getOwnPropertySymbols,
  oe = Object.prototype.hasOwnProperty,
  se = Object.prototype.propertyIsEnumerable,
  ae = (e, t, r) => t in e ? re(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  le = (e, t) => {
    for (var r in t || (t = {})) oe.call(t, r) && ae(e, r, t[r]);
    if (ne) for (var r of ne(t)) se.call(t, r) && ae(e, r, t[r]);
    return e;
  };
function ie() {
  let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    clientOnly: !1
  };
  return function (r) {
    return n => e.createElement(y, null, _ref3 => {
      let {
        flags: o,
        ldClient: s
      } = _ref3;
      return t.clientOnly ? e.createElement(r, le({
        ldClient: s
      }, n)) : e.createElement(r, le({
        flags: o,
        ldClient: s
      }, n));
    });
  };
}
const ce = () => {
    const {
      flags: e
    } = a(u);
    return e;
  },
  pe = () => {
    const {
      ldClient: e
    } = a(u);
    return e;
  };
function ue() {
  const {
    error: e
  } = a(u);
  return e;
}
export { $ as LDProvider, te as asyncWithLDProvider, g as camelCaseKeys, p as defaultReactOptions, ce as useFlags, pe as useLDClient, ue as useLDClientError, ie as withLDConsumer, Q as withLDProvider };